module.exports = __webpack_public_path__ + "fonts/unicons-line.16e4040.woff2";